import { t } from 'i18next';
import { toast } from 'react-toastify';

import { doRequest } from '~utils/request';

const APIS = {
  USERS: '/api/core/users/',
  IPS: '/api/core/ips/',
  IPS_BRANCH: '/api/core/ips_branch/',
  CITIES: '/api/core/cities/',
  NAV_BAR: '/api/core/nav-bar/',
  NEWS: '/api/core/news/'
};

export const getUser = async (): Promise<User | null> => {
  let value = null;

  await doRequest<User, undefined, UserError>({
    type: 'private',
    url: APIS.USERS,
    method: 'GET',
    thenFn: (res) => (value = res),
    catchFn: (err) => {
      if (err?.detail) toast.error(t(err.detail));
      value = null;
    }
  });

  return value;
};

export const getSidebar = async (): Promise<Sidebar | null> => {
  let value = null;

  await doRequest<unknown, undefined, RequestError>({
    type: 'private',
    url: APIS.NAV_BAR,
    method: 'GET',
    thenFn: (res) => (value = res),
    catchFn: (err) => {
      if (err?.detail) toast.error(t(err.detail));
      value = null;
    }
  });

  return value;
};

export const getIpsBranch = async (
  params: object
): Promise<IpsBranch[] | null> => {
  let value = null;

  await doRequest<ResultsResponse<IpsBranch>, object, RequestError>({
    type: 'private',
    url: APIS.IPS_BRANCH,
    method: 'GET',
    params,
    thenFn: (res) => (value = res.results),
    catchFn: () => (value = null)
  });

  return value;
};

export const getIPS = async (params: object): Promise<Ips[] | null> => {
  let value = null;

  await doRequest<ResultsResponse<Ips>, object, RequestError>({
    type: 'private',
    url: APIS.IPS,
    method: 'GET',
    params,
    thenFn: (res) => (value = res.results),
    catchFn: () => (value = null)
  });

  return value;
};
